import type { Notebook } from '@/features/Notes/types';

import type { CreatableOptionType, Option } from './types';

export const isNotebook = (option: Option): option is Notebook =>
  !Object.keys(option).includes('title');
export const isCreatable = (option: Option): option is CreatableOptionType =>
  Object.keys(option).includes('title');
